// BCM-898 · Goods Receipt Dashboard — small shared formatting/validation helpers.
import moment from "moment";

// "Special Stocks with Vendor" == absence of a storage location.
// Mirrors isSpecialStockWithVendor() in
// sasl/deliveryScheduleBatchTable/POColumns/EditPlannedAllocatedQuantityDialog.jsx.
export const isSpecialStockWithVendor = (storageLocation) =>
  storageLocation === null ||
  storageLocation === undefined ||
  storageLocation === "" ||
  storageLocation === 0 ||
  storageLocation === "0";

export const formatStorageLocation = (storageLocation) =>
  isSpecialStockWithVendor(storageLocation)
    ? "Special Stocks with Vendor"
    : String(storageLocation);

// Expiry is "in the past" strictly before start of today.
export const isExpired = (expiryDate) => {
  if (!expiryDate) return false; // cannot corroborate — do NOT treat as expired
  const d = moment(expiryDate);
  return d.isValid() && d.isBefore(moment().startOf("day"));
};

// Whole days elapsed since an expiry date (>=0). Returns null when undeterminable.
export const daysElapsedSince = (date) => {
  if (!date) return null;
  const d = moment(date);
  if (!d.isValid()) return null;
  return Math.max(0, moment().startOf("day").diff(d.startOf("day"), "days"));
};

export const formatDate = (date) =>
  date && moment(date).isValid() ? moment(date).format("DD-MMM-YYYY") : "-NA-";

// Date + time, e.g. "10 AUG 2026 00:00:00" — the "Last shipped at" rendering the
// Batch Execution dialogs use for a partially shipped batch.
export const formatDateTime = (date) =>
  date && moment(date).isValid()
    ? moment(date).format("DD MMM YYYY HH:mm:ss").toUpperCase()
    : "-NA-";

// A number rounded to at most 3 dp, gracefully passing through non-numbers.
export const trimQty = (value) => {
  if (value === null || value === undefined || value === "") return value;
  const n = Number(value);
  if (!Number.isFinite(n)) return value;
  return parseFloat(n.toFixed(3));
};

// Three-valued flags pass through toBoolOrNull server-side; compare with === true.
// null means "not evaluated", which is NOT the same as false (API Reference §flags).
export const isFlagTrue = (flag) => flag === true;

export const lastSyncedLabel = (date) =>
  `Last synced @ ${moment(date || new Date()).format("HH:mm:ss; DD MMMM, YYYY")}`;
